import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/admin/Login'
import Lebenslauf from '@/admin/Lebenslauf'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {title: 'Login'}
    },
    {
      path: '/',
      name: 'lebenslauf',
      component: Lebenslauf,
      meta: {title: 'Lebenslauf'}
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router






// WEBPACK FOOTER //
// ./src/router/index.js